export const GET_VEHICLE = 'GetVehicle';
export const SAVE_VEHICLE = 'SaveVehicle';
export const GET_VEHICLE_EVENTS = 'GetVehicleEvents';
